module.exports = __webpack_public_path__ + "img/icon-arrow-up.54e01075.svg";